module.exports = __webpack_public_path__ + "593a3d53/img/scraper-icon.df6ccde5.svg";